// app/commessa/commesse.js
(function () {
    'use strict';
    var controllerId = 'commessa';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$routeParams', '$filter', '$location', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', commessaFn]);

    function commessaFn($rootScope, $scope, $routeParams, $filter, $location, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this, onRouteChangeOff;
        vm.title = $translate.instant('Commesse');
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection('Commesse');                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;        
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.enabledPrint = false;
        vm.readonly = false;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        vm.capoSezione = $rootScope.isAuthorized('CAPOSEZIONE');
        vm.utente = $rootScope.isAuthorized('USER');
        vm.addDisabled = vm.utente;
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Codice', 'Titolo', 'Stato', 'Data aggiornamento'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[3];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        vm.item = {};

        vm.list.attivita = [];
        vm.list.clienti = [];
        vm.list.tipoAssegnazione = [];
        vm.list.tipoPrestazione = [];
        vm.list.budget = [];
        vm.list.dipendenti = [];
        vm.list.commesseSezioni = [];
        vm.list.dipendentiList = [];
        
        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = -2;
        vm.filter.ricerca = vm.fRicerca = '';
        vm.filter.cliente = vm.fCliente = 0;
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;
        vm.add = addCommessa;
        vm.delete = deleteItem;
        vm.update = updateItem;
        vm.chiudiCommessa = chiudiCommessa;
        vm.riapriCommessa = riapriCommessa;
        vm.aggiornaStatoCommessa = aggiornaStatoCommessa;

        vm.confirmRoute = confirmRoute;

        //attivita
        vm.getListAttivita = getListAttivita;
        vm.addAttivita = addAttivita;
        vm.editAttivita = editAttivita;
        vm.deleteAttivita = deleteAttivita;

        //budget
        vm.addBudget = addBudget;
        vm.deleteBudget = deleteBudget;

        //dipendentiCommessa
        vm.getListDipendenti = getListDipendenti;
        vm.selezionaDipendente = selezionaDipendente;
        vm.deleteDipendenteCommessa = deleteDipendenteCommessa;

        //commesseSezioni
        vm.getListCommesseSezioni = getListCommesseSezioni;
        vm.addCommessaSezione = addCommessaSezione;
        vm.editCommessaSezione = editCommessaSezione;
        vm.deleteCommessaSezione = deleteCommessaSezione;

        vm.dict_selected_assegnazione = [];
        vm.dict_tassegnazione = {};
        vm.dict_selected_prestazione = [];
        vm.dict_tprestazione = {};

        //report
        vm.report = report;

        //datapicker
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened2 = vm.opened3 = vm.opened4 = vm.opened5 = vm.opened6 = false;
        };

        vm.open2 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened2 = !vm.opened2;
            vm.opened = vm.opened3 = vm.opened4 = vm.opened5 = vm.opened6 = false;
        };

        vm.open3 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened3 = !vm.opened3;
            vm.opened2 = vm.opened = vm.opened4 = vm.opened5 = vm.opened6 = false;
        };

        vm.open4 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened4 = !vm.opened4;
            vm.opened2 = vm.opened3 = vm.opened = vm.opened5 = vm.opened6 = false;
        };

        vm.open5 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened5 = !vm.opened5;
            vm.opened2 = vm.opened3 = vm.opened = vm.opened4 = vm.opened6 = false;
        };

        vm.open6 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened6 = !vm.opened6;
            vm.opened2 = vm.opened3 = vm.opened = vm.opened4 = vm.opened5 = false;
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getListClienti(), getListTipoAssegnazione(), getListTipoPrestazione(), getAllListDipendenti()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.CommessaId != null) {
                        setView('detail');
                        getRecord($routeParams.CommessaId, 0);
                    }
                });
        }

        //****************************************************
        /*CONFIRM SAVE BEFORE CHANGE ROUTE */
        //****************************************************
        function init() {
            //initialize data here..    
            vm.item.editForm = false;

            //Make sure they"re warned if they made a change but didn"t save it
            //Call to $on returns a "deregistration" function that can be called to
            //remove the listener (see routeChange() for an example of using it)
            onRouteChangeOff = $scope.$on("$locationChangeStart", routeChange);
        }
        init();

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            if (view == 'list')
                cerca();
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.cliente = vm.fCliente == null ? 0 : vm.fCliente;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.commessa_countAll(vm.filter.ricerca, vm.filter.cliente, vm.filter.stato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.commessa_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.cliente, vm.filter.stato, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;                
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            vm.list.attivita = [];
            vm.list.budget = [];
            return datacontext.commessa_get(id).then(function (data) {
                vm.index = index;

                if (data.DataApertura)
                    data.DataApertura = new Date(data.DataApertura);
                if (data.DataChiusura)
                    data.DataChiusura = new Date(data.DataChiusura);
                if (data.DataAggiornamento)
                    data.DataAggiornamento = new Date(data.DataAggiornamento);
                if (data.DataScadenza)
                    data.DataScadenza = new Date(data.DataScadenza);
                if (data.DataRev)
                    data.DataRev = new Date(data.DataRev);

                if (data.Stato == 2) //commessa chiusa
                    vm.readonly = true;
                else
                    vm.readonly = false;

                if (data.Budget.length > 0) {
                    data.Budget.forEach(function (o) {
                        var obj = { Id: o.Id, Name: o.Budget + ' (' + $filter('date')(o.Data, 'dd/MM/yyyy') + ')' };
                        vm.list.budget.push(obj);
                    });
                }

                if (data.TassegnazioneName!=null)
                //popolo le selezioni di tipo assegnazione
                vm.dict_selected_assegnazione = data.TassegnazioneName.split(',');
                //popolo le selezioni di tipo prestazione
                if (data.TprestazioneName != null)
                vm.dict_selected_prestazione = data.TprestazioneName.split(',');

                vm.record = data;

                if (vm.utente)
                    checkTeamLeaderCommessa(id);

                if (!$rootScope.bSezioni)
                    getListAttivita(id);
                else
                    getListCommesseSezioni(id);
                getListDipendenti(id);

                setView('detail');
            });
        }

        function addCommessa() {
            var modalCommessa = {};
            modalCommessa.Id = 0;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/commessaAdd.html?version=30',
                controller: 'commessaAdd',
                resolve: {
                    commessa: function () {
                        return modalCommessa;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante inserimento del dato'));

                logSuccess($translate.instant('Commessa aggiunta con successo'));
                $location.url('/commesse/' + returnItem.Id);
            });
        }

        function updateItem() {
            vm.record.TassegnazioneName = vm.dict_selected_assegnazione.join();
            vm.record.TprestazioneName = vm.dict_selected_prestazione.join();

            return datacontext.commessa_update(vm.record).then(function (data) {
                if (data) {
                    if (vm.record.DataApertura)
                        vm.record.DataApertura = new Date(data.DataApertura);
                    if (vm.record.DataChiusura)
                        vm.record.DataChiusura = new Date(data.DataChiusura);
                    if (vm.record.DataAggiornamento)
                        vm.record.DataAggiornamento = new Date(data.DataAggiornamento);
                    if (vm.record.DataScadenza)
                        vm.record.DataScadenza = new Date(data.DataScadenza);
                    if (data.DataRevisione)
                        data.DataRevisione = new Date(data.DataRevisione);

                    if (vm.recordForm)
                        vm.recordForm.$setPristine();

                    logSuccess($translate.instant('Dati salvati'));
                } else {
                    return logError($translate.instant('Impossibile salvare i dati'));
                }
            });
        }

        function deleteItem(item) {
            var msg = " " + $translate.instant('la commessa') + " " + item.Codice;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.commessa_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Impossibile eliminare la commessa') + " " + item.Codice);
                    logSuccess($translate.instant('Commessa eliminata con successo'));
                    cerca();
                });
            });
        }

        function report(estensione) {
            if (vm.loading == true)
                return;

            vm.loading = estensione;
            datacontext.report_Commessa(vm.record.Id, estensione).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    //if (bPDF)
                      //  var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function checkTeamLeaderCommessa(id) {
            return datacontext.commessa_checkTeamLeader(id).then(function (data) {
                if (data) {
                    vm.capoSezione = true;
                } else
                    vm.readonly = true;
                    
            });
        }

        function aggiornaStatoCommessa(stato) {
            var title = '';
            var msg = '';
            var conferma = '';

            switch (stato) {
                case 0: title = $translate.instant('Commessa in offerta');
                    msg = $translate.instant('Sei sicuro di voler mettere in offerta la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                    conferma = $translate.instant('Commessa in offerta');
                    break;
                case 1:
                    if (vm.record.Stato == 0 || vm.record.Stato == 3) {
                        title = $translate.instant('Apri commessa');
                        msg = $translate.instant('Sei sicuro di voler aprire la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                        conferma = $translate.instant('Commessa Aperta');
                    } else if (vm.record.Stato == 2 || vm.record.Stato == 4) {
                        title = $translate.instant('Riapri commessa');
                        msg = $translate.instant('Sei sicuro di voler riaprire la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                        conferma = $translate.instant('Commessa Aperta');
                    }
                    break;
                case 2:
                    title = $translate.instant('Chiudi commessa');
                    msg = $translate.instant('Sei sicuro di voler chiudere la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                    conferma = $translate.instant('Commessa Chiusa');
                    break;
                case 3:
                    title = $translate.instant('Sospendi commessa');
                    msg = $translate.instant('Sei sicuro di voler sospendere la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                    conferma = $translate.instant('Commessa Sospesa');
                    break;
                case 4:
                    title = $translate.instant('Annulla commessa');
                    msg = $translate.instant('Sei sicuro di voler annullare la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?';
                    conferma = $translate.instant('Commessa Annullata');
                    break;
                default: break;
            }

            bDialog.confirmationDialog(title, msg, 'OK', $translate.instant('Annulla')).then(function () { //YES
                return datacontext.commessa_aggiornaStato(vm.record.Id, stato).then(function (data) {
                    logSuccess(conferma);
                    getRecord(vm.record.Id);
                });
            }, function (btn) { // NO
            });
        }

        function chiudiCommessa() {
            bDialog.confirmationDialog($translate.instant('Chiudi commessa'), $translate.instant('Sei sicuro di voler chiudere la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?', 'OK', $translate.instant('Annulla')).then(function () { //YES
                return datacontext.commessa_chiudiCommessa(vm.record).then(function (data) {
                    logSuccess($translate.instant('Commessa Chiusa'));
                    getRecord(vm.record.Id);
                });
            }, function (btn) { // NO
                    vm.readonly = false;
            });
        }

        function riapriCommessa() {
            bDialog.confirmationDialog($translate.instant('Riapri commessa'), $translate.instant('Sei sicuro di voler riaprire la commessa') + " " + vm.record.Codice + ' - ' + vm.record.Titolo + '?', 'OK', $translate.instant('Annulla')).then(function () { //YES
                return datacontext.commessa_riapriCommessa(vm.record).then(function (data) {
                    logSuccess($translate.instant('Commessa Aperta'));
                    getRecord(vm.record.Id);
                });
            }, function (btn) { //NO
                vm.readonly = true;
            });
        }
        

        vm.calcolaTotaleSpese = function () {
            if (vm.record.CostoOrarioMedio && vm.record.OrePreviste) {
                vm.record.TotaleSpesaPrevista = vm.record.CostoOrarioMedio * vm.record.OrePreviste;
                vm.record.TotaleSpesaPrevista = parseFloat(vm.record.TotaleSpesaPrevista.toFixed(2));
            }
            if (vm.record.CostoOrarioMedio && vm.record.OreSpese) {
                vm.record.TotaleSpesaEffettiva = vm.record.CostoOrarioMedio * vm.record.OreSpese;
                vm.record.TotaleSpesaEffettiva = parseFloat(vm.record.TotaleSpesaEffettiva.toFixed(2));
            }
        };

        function confirmRoute(event, newUrl) {
            var attempt = true;

            if (vm.recordForm)
                vm.item.editForm = vm.recordForm.$dirty;

            if (vm.item.editForm) {
                bDialog.confirmationDialog($translate.instant('Modifiche non salvate'), $translate.instant('Sono presenti modifiche non salvate'), $translate.instant('Salva modifiche e procedi'), $translate.instant('Annulla modifiche e procedi')).then(function () { //YES
                    if (vm.recordForm.$valid) {
                        vm.update(vm.recordForm.$event);

                        vm.item.editForm = false;
                        onRouteChangeOff(); //Stop listening for location changes

                        if (newUrl == '') {
                            $location.url("/commesse");
                        }
                        else
                            $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                        return attempt;
                    } else {
                        logError($translate.instant('Compilare i campi obbligatori'));
                        return attempt;
                    }
                }, function (btn) { // NO
                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    if (newUrl == '') {
                        $location.url("/commesse");
                    }
                    else
                        $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                    vm.change = 0;
                    return attempt;
                });
            }
            else {
                attempt = false;
                vm.item.editForm = false;
                onRouteChangeOff(); //Stop listening for location changes
                if (newUrl == '') {
                    $location.url("/commesse");

                    vm.index = 0;
                }
                else
                    $location.path($location.url(newUrl).hash()); //Go to page they're interested in   
            }

            return attempt;
        }

        function routeChange(event, newUrl, oldUrl) {
            vm.change++;
            if (vm.change == 1) {
                if (confirmRoute(event, newUrl, vm.recordForm)) {
                    event.preventDefault();
                    return;
                }
            }
        }

        function getListClienti() {
            return datacontext.cliente_getAllList().then(function (data) {
                return vm.list.clienti = data;
            });
        }

        function getListTipoAssegnazione() {
            return datacontext.tipoAssegnazione_getAllList().then(function (data) {
                vm.list.tipoAssegnazione = data;
                for (var i = 0; i < Object.keys(vm.list.tipoAssegnazione).length; i++) {
                    var ennesimo = vm.list.tipoAssegnazione[i].Name;
                    vm.dict_tassegnazione[ennesimo] = vm.list.tipoAssegnazione[i].Name;
                }

                return vm.list.tipoAssegnazione;
            });
        }
        function getListTipoPrestazione() {
            return datacontext.tipoPrestazione_getAllList().then(function (data) {
                vm.list.tipoPrestazione = data;
                for (var i = 0; i < Object.keys(vm.list.tipoPrestazione).length; i++) {
                    var ennesimo = vm.list.tipoPrestazione[i].Name;
                    vm.dict_tprestazione[ennesimo] = vm.list.tipoPrestazione[i].Name;
                }
                return vm.list.tipoPrestazione = data;
            });
        }
        //Gestione attivita
        function getListAttivita(commessaId) {
            return datacontext.attivita_getAll(commessaId).then(function (data) {
                vm.list.attivita = data;
                calcolaOrePreviste();
                vm.calcolaTotaleSpese();
            });
        }

        function calcolaOrePreviste() {
            vm.record.OrePreviste = 0;
            vm.list.attivita.forEach(function (o) {
                vm.record.OrePreviste += o.OrePreviste;
                vm.record.OrePreviste = parseFloat(vm.record.OrePreviste.toFixed(2));
            });
        }

        function addAttivita() {
            var modalAttivita = {};
            modalAttivita.Id = 0;
            modalAttivita.CommessaId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/attivitaAddEdit.html?version=30',
                controller: 'attivitaAddEdit',
                resolve: {
                    attivita: function () {
                        return modalAttivita;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante inserimento del dato'));

                logSuccess($translate.instant('Attivita aggiunta con successo'));
                getListAttivita(vm.record.Id);
            });
        }

        function editAttivita(item) {
            var modalAttivita = {};
            angular.copy(item, modalAttivita);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/attivitaAddEdit.html?version=30',
                controller: 'attivitaAddEdit',
                resolve: {
                    attivita: function () {
                        return modalAttivita;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Attivita modificata con successo'));
                getListAttivita(vm.record.Id);
            });
        }

        function deleteAttivita(item) {
            var msg = $translate.instant('Lattivita ') + item.Codice + ' - ' + item.Descrizione;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attivita_delete(item.Id).then(function (data) {
                    if (!data) return logError($translate.instant('Errore durante la rimozione del dato'));
                    getListAttivita(vm.record.Id);
                });
            });
        }

        //Gestione budget
        function addBudget() {
            var modalBudget = {};
            modalBudget.Id = 0;
            modalBudget.CommessaId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/budgetAdd.html?version=30',
                controller: 'budgetAdd',
                resolve: {
                    budget: function () {
                        return modalBudget;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante inserimento del dato'));

                logSuccess($translate.instant('Budget aggiunto con successo'));
                getRecord(vm.record.Id);
            });
        }


        function deleteBudget(id) {
            var index = _.findIndex(vm.record.Budget, function (o) {
                return o.Id === id;
            });

            var item = {};
            if (index != -1)
                item = vm.record.Budget[index];

            var msg = $translate.instant('il') + " " + "bugdet " + item.Budget + " " + $translate.instant('del') + " " + $filter('date')(item.Data, 'dd/MM/yyyy');
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.budgetCommessa_delete(id).then(function (data) {
                    if (!data) return logError($translate.instant('Errore durante la rimozione del dato'));
                    getRecord(vm.record.Id);
                });
            });
        }


        //Gestione membri team
        //getListDipendenti (popolare i dipendenti per la commessa)
        function getListDipendenti(id) {
            if (!id) return [];
            var temp = [];
            //Questo metodo serve nella schermata dettaglio team           
            return datacontext.dipendentiCommessa_getAll(id, 0).then(function (data) {
                if (vm.dipendentiAttivi == true) {
                    data.forEach(function (item) {
                        if (item.attivo == true) {
                            temp.push(item);
                        }
                    });

                    return vm.list.dipendenti = temp;
                }
                else
                    return vm.list.dipendenti = data;
            });
        }

        function getAllListDipendenti() {
            return datacontext.dipendente_getAllList().then(function (data) {
                return vm.list.dipendentiList = data;
            });
        }

        //getDipendenti (popolare la modale dei dipendenti)
        function getDipendente(id) {
            if ($rootScope.isAuthorized('USER') || !id)
                id = $rootScope.id ? $rootScope.id : 0;

            return datacontext.dipendente_get(id).then(function (data) {
                vm.dipendente = data;
            });
        }

        // Selezione dipendente
        function selezionaDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/commessaMembroSelect.html?version=30',
                controller: 'commessaMembroSelect',
                windowClass: 'modal-wide',
                resolve: {
                    commessaId: function () {
                        return vm.record.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "409")
                    return logError($translate.instant('Dipendente gia presente'));
                else if (returnItem == "300")
                    return logError($translate.instant('Leader gia presente'));
                else if (returnItem == "400" || returnItem == "404")
                    return logError($translate.instant('Impossibile salvare i dati'));
                else {
                    logSuccess($translate.instant('Dati salvati'));
                    return getListDipendenti(vm.record.Id);
                }
            });
        }

        function deleteDipendenteCommessa(item) {
            if (vm.capoSezione) {
                if (item.ruolo == "L") {
                    logError($translate.instant('Non e possibile eliminare il leader'));
                    return;
                }
            }

            var msg = $translate.instant('il dipendente') + " " + item.dipendente + " " + $translate.instant('dalla commessa') + " " + vm.record.Codice + " - " + vm.record.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendentiCommessa_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Dipendente eliminato con successo'));
                    //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                    getListDipendenti(vm.record.Id);
                });
            });
        }

        //Gestione commesse sezioni
        function getListCommesseSezioni(id) {
            if (!id) return [];         
            return datacontext.commessaSezione_getAll(id, 0).then(function (data) {
                return vm.list.commesseSezioni = data;
            });
        }

        function addCommessaSezione() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/commessaSezioneAdd.html?version=30',
                controller: 'commessaSezioneAdd',
                windowClass: 'modal-wide',
                resolve: {
                    commessaId: function () {
                        return vm.record.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "409")
                    return logError($translate.instant('Centro di costo gia presente'));
                else if (returnItem == "400" || returnItem == "404")
                    return logError($translate.instant('Impossibile salvare i dati'));
                else {
                    logSuccess($translate.instant('Dati salvati'));
                    return getListCommesseSezioni(vm.record.Id);
                }
            });
        }

        function editCommessaSezione(item) {
            var modalSezione = {};
            angular.copy(item, modalSezione);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/commessa/modal/commessaSezioneEdit.html?version=30',
                controller: 'commessaSezioneEdit',
                resolve: {
                    sezione: function () {
                        return modalSezione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Centro di costo modificato con successo'));
                getListCommesseSezioni(vm.record.Id);
            });
        }

        function deleteCommessaSezione(item) {
            var msg = $translate.instant('il') + " " + $translate.instant('CentroDiCosto') + " " + item.sezione + " " + $translate.instant('dalla commessa') + " " + vm.record.Codice + " - " + vm.record.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.commessaSezione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Dipendente eliminato con successo'));
                    getListCommesseSezioni(vm.record.Id);
                });
            });
        }

    }
})();
